<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header card-header-detail" i18n>Erklärung</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-md-12">
          <span [class.mandatory]="isMandatory('vorbestraftJaNein')" i18n>Sind Sie vorbestraft?</span>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio"
                     id="erklaerung.vorbestraft.nein"
                     class="form-check-input"
                     formControlName="vorbestraftJaNein"
                     name="vorbestraftJaNein"
                     value="nein"
                     [checked]="true"
                     [ngbPopover]="popVorbestraftJaNein"
                     appSaveLastFocussed
              >
              <span i18n>nein</span>
            </label>
            <label class="form-check-label ms-5">
              <input type="radio"
                     id="erklaerung.vorbestraft.ja"
                     class="form-check-input"
                     formControlName="vorbestraftJaNein"
                     name="vorbestraftJaNein"
                     value="ja"
                     [ngbPopover]="popVorbestraftJaNein"
                     appSaveLastFocussed
              >
              <span i18n>ja</span>
            </label>
          </div>
          <ng-template #popVorbestraftJaNein>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bitte beachten Sie, dass sowohl Vorstrafen in Deutschland als auch in weiteren Ländern (Ausland) zu benennen sind.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>
      <div class="mb-2" *ngIf="form.value.vorbestraftJaNein === 'ja'">
        <div class="row">
          <div class="col" i18n>In Deutschland</div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeInDeutschland.wannUndWo" i18n>Wann und wo?</label><br>
              <input id="erklaerung.strafeInDeutschland.wannUndWo"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftDeutschlandWann')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftDeutschlandWann'])"
                     formControlName="vorbestraftDeutschlandWann"
                     [ngbPopover]="popVorbestraftDeutschlandWann"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftDeutschlandWann>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Ort und das Datum der in Deutschland erhaltenen Vorstrafe(n) ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeInDeutschland.grund" i18n>Grund:</label><br>
              <input id="erklaerung.strafeInDeutschland.grund"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftDeutschlandGrund')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftDeutschlandGrund'])"
                     formControlName="vorbestraftDeutschlandGrund"
                     [ngbPopover]="popVorbestraftDeutschlandGrund"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftDeutschlandGrund>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier auf Deutsch oder Englisch den Grund für die in Deutschland erhaltene(n) Vorstrafe(n) ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeInDeutschland.artUndHoeheDerStrafe" i18n>Art und Höhe der Strafe:</label><br>
              <input id="erklaerung.strafeInDeutschland.artUndHoeheDerStrafe"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftDeutschlandHoehe')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftDeutschlandHoehe'])"
                     formControlName="vorbestraftDeutschlandHoehe"
                     [ngbPopover]="popVorbestraftDeutschlandHoehe"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftDeutschlandHoehe>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier auf Deutsch oder Englisch die Art und Höhe der in Deutschland erhaltenen Vorstrafe(n) ein.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col" i18n>Im Ausland</div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeImAusland.wannUndWo" i18n>Wann und wo?</label><br>
              <input id="erklaerung.strafeImAusland.wannUndWo"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftAuslandWann')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftAuslandWann'])"
                     formControlName="vorbestraftAuslandWann"
                     [ngbPopover]="popVorbestraftAuslandWann"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftAuslandWann>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier den Ort und das Datum der im Ausland erhaltenen Vorstrafe(n) ein. Berücksichtigen Sie bitte auch Vorstrafen aus dem Heimatland.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeImAusland.grund" i18n>Grund:</label><br>
              <input id="erklaerung.strafeImAusland.grund"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftAuslandGrund')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftAuslandGrund'])"
                     formControlName="vorbestraftAuslandGrund"
                     [ngbPopover]="popVorbestraftAuslandGrund"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftAuslandGrund>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier auf Deutsch oder Englisch den Grund für die im Ausland erhaltene(n) Vorstrafe(n) ein. Berücksichtigen Sie bitte auch Vorstrafen aus dem Heimatland.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-check">
              <label for="erklaerung.strafeImAusland.artUndHoeheDerStrafe" i18n>Art und Höhe der Strafe:</label><br>
              <input id="erklaerung.strafeImAusland.artUndHoeheDerStrafe"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('vorbestraftAuslandHoehe')"
                     class="form-control form-control-sm"
                     [class.is-invalid]="errorClassRequired(form.controls['vorbestraftAuslandHoehe'])"
                     formControlName="vorbestraftAuslandHoehe"
                     [ngbPopover]="popVorbestraftAuslandHoehe"
                     appSaveLastFocussed
              >
              <ng-template #popVorbestraftAuslandHoehe>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte tragen Sie hier auf Deutsch oder Englisch die Art und Höhe der im Ausland erhaltenen Vorstrafe(n) ein. Berücksichtigen Sie bitte auch Vorstrafen aus dem Heimatland.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <span [class.mandatory]="isMandatory('ausgewiesenJaNein')" i18n>Sind Sie aus der Bundesrepublik Deutschland schon einmal ausgewiesen oder abgeschoben worden oder ist ein Antrag auf Erteilung einer Aufenthaltserlaubnis abgelehnt oder eine Einreise in die Bundesrepublik Deutschland verweigert worden?</span>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio"
                     id="erklaerung.ausgewiesen.nein"
                     class="form-check-input"
                     value="nein"
                     formControlName="ausgewiesenJaNein"
                     name="ausgewiesenJaNein"
                     [checked]="true"
                     [ngbPopover]="popAusgewiesenJaNein"
                     appSaveLastFocussed
              >
              <span i18n>nein</span>
            </label>
            <label class="form-check-label ms-5">
              <input type="radio"
                     id="erklaerung.ausgewiesen.ja"
                     class="form-check-input"
                     value="ja"
                     formControlName="ausgewiesenJaNein"
                     name="ausgewiesenJaNein"
                     [ngbPopover]="popAusgewiesenJaNein"
                     appSaveLastFocussed
              >
              <span i18n>ja</span>
            </label>
          </div>
          <ng-template #popAusgewiesenJaNein>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span
                i18n>Bitte tragen Sie hier wahrheitsgemäß die erforderlichen Angaben zu der Person ein, für welche der Visumantrag gestellt wird.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>
      <div class="row mb-2" *ngIf="form.value.ausgewiesenJaNein === 'ja'">
        <div class="col-md-12">
          <div class="form-check">
            <label for="erklaerung.ausgewiesenAngaben" i18n>Nähere Angaben:</label>
            <input id="erklaerung.ausgewiesenAngaben"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('ausgewiesenGrund')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['ausgewiesenGrund'])"
                   formControlName="ausgewiesenGrund"
                   [ngbPopover]="popAusgewiesenGrund"
                   appSaveLastFocussed
            >
            <ng-template #popAusgewiesenGrund>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie Ihre Angaben auf Deutsch oder Englisch ein. Nutzen Sie für längere Ausführungen ggf. ein Zusatzblatt und legen dieses zusammen mit dem Antrag vor.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <span [class.mandatory]="isMandatory('krankJaNein')" i18n>Leiden Sie an einer der folgenden Krankheiten?</span><br>
          <span i18n>Pocken, Poliomyelitis, beim Menschen nicht verbreitete Influenzatypen (z. B. "Vogelgrippe", "Schweinegrippe"), Influenza im Falle einer akuten Pandemie, schweres akutes Atemwegssyndrom (SARS), Cholera, Lungenpest, Gelbfieber sowie virale hämorrhagische Fieber (z. B. Ebola, Lassa, Marburg)</span>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio"
                     id="erklaerung.krankheiten.nein"
                     class="form-check-input"
                     value="nein"
                     formControlName="krankJaNein"
                     name="krankJaNein"
                     [checked]="true"
                     [ngbPopover]="popKrankJaNein"
                     appSaveLastFocussed
              >
              <span i18n>nein</span>
            </label>
            <label class="form-check-label ms-5">
              <input type="radio"
                     id="erklaerung.krankheiten.ja"
                     class="form-check-input"
                     value="ja"
                     formControlName="krankJaNein"
                     name="krankJaNein"
                     [ngbPopover]="popKrankJaNein"
                     appSaveLastFocussed
              >
              <span i18n>ja</span>
            </label>
            <ng-template #popKrankJaNein>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte aktivieren Sie das Kästchen, wenn die Person, für welche der Visumantrag gestellt wird, an einer der folgenden Krankheiten leidet.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div *ngIf="form.value.krankJaNein === 'ja'"
           class="row"
      >
        <div class="col-md-12">
          <div class="form-check">
            <label for="erklaerung.krankheitenAngaben" i18n>Nähere Angaben:</label>
            <input id="erklaerung.krankheitenAngaben"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('krankInfos')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['krankInfos'])"
                   formControlName="krankInfos"
                   [ngbPopover]="popKrankInfos"
                   appSaveLastFocussed
            >
            <ng-template #popKrankInfos>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie Ihre Angaben auf Deutsch oder Englisch ein. Nutzen Sie für längere Ausführungen ggf. ein Zusatzblatt und legen dieses zusammen mit dem Antrag vor.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
